import { render, staticRenderFns } from "./ConversationHeader.vue?vue&type=template&id=5723e255&scoped=true&"
import script from "./ConversationHeader.vue?vue&type=script&lang=js&"
export * from "./ConversationHeader.vue?vue&type=script&lang=js&"
import style0 from "./ConversationHeader.vue?vue&type=style&index=0&id=5723e255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5723e255",
  null
  
)

export default component.exports